import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { CanvasContext } from "../../../contexts/CanvasContext";

const RadioComponent = ({ radio = {} }) => {
  const { hoveredDivision, files } = useContext(CanvasContext);
  const [isChecked, setIsChecked] = useState(radio.checked || false);

  const handleCheckboxChange = (checked) => {
    setIsChecked(checked); // Update the checked state
  };

  const isHovered = radio.id === hoveredDivision;
  const [isDivHovered, setIsDivHovered] = useState(false);
  const [isDivFocused, setIsDivFocused] = useState(false);
  const [isDivActive, setIsDivActive] = useState(false);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(null);
  const [backgroundImagelabelUrl, setlabelbackgroundImagelabelUrl] =
    useState(null);

  const constructGradientString = () => {
    const {
      backgroundGradientImage,
      gradientDirection,
      gradientShape,
      gradientPosition,
      startColor,
      endColor,
      gradientAngle,
      patternLength,
    } = radio;

    switch (backgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${gradientDirection || "to right"}, ${
          startColor || "#ff7e5f"
        }, ${endColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${gradientAngle || "45"}deg, ${
          startColor || "#606dbc"
        }, ${endColor || "#465298"} ${patternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"} ${
          patternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const labelconstructGradientString = () => {
    const {
      labelbackgroundGradientImage,
      labelgradientDirection,
      labelgradientShape,
      labelgradientPosition,
      labelstartColor,
      labelendColor,
      labelgradientAngle,
      labelpatternLength,
    } = radio;

    switch (labelbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${labelgradientDirection || "to right"}, ${
          labelstartColor || "#ff7e5f"
        }, ${labelendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${labelgradientShape || "circle"} at ${
          labelgradientPosition || "center"
        }, ${labelstartColor || "#ff7e5f"}, ${labelendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${labelgradientAngle || "45"}deg, ${
          labelstartColor || "#606dbc"
        }, ${labelendColor || "#465298"} ${labelpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          labelgradientShape || "circle"
        } at ${labelgradientPosition || "center"}, ${
          labelstartColor || "#ff7e5f"
        }, ${labelendColor || "#feb47b"} ${labelpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructHoverGradientString = () => {
    const {
      hoveredbackgroundGradientImage,
      hoveredgradientDirection,
      hoveredgradientShape,
      hoveredgradientPosition,
      hoveredstartColor,
      hoveredendColor,
      hoveredgradientAngle,
      hoveredpatternLength,
    } = radio;

    switch (hoveredbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${hoveredgradientDirection || "to right"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${hoveredgradientShape || "circle"} at ${
          hoveredgradientPosition || "center"
        }, ${hoveredstartColor || "#ff7e5f"}, ${hoveredendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${hoveredgradientAngle || "45"}deg, ${
          hoveredstartColor || "#606dbc"
        }, ${hoveredendColor || "#465298"} ${hoveredpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          hoveredgradientShape || "circle"
        } at ${hoveredgradientPosition || "center"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"} ${hoveredpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructFocusedGradientString = () => {
    const {
      focusedbackgroundGradientImage,
      focusedgradientDirection,
      focusedgradientShape,
      focusedgradientPosition,
      focusedstartColor,
      focusedendColor,
      focusedgradientAngle,
      focusedpatternLength,
    } = radio;

    switch (focusedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${focusedgradientDirection || "to right"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${focusedgradientShape || "circle"} at ${
          focusedgradientPosition || "center"
        }, ${focusedstartColor || "#ff7e5f"}, ${focusedendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${focusedgradientAngle || "45"}deg, ${
          focusedstartColor || "#606dbc"
        }, ${focusedendColor || "#465298"} ${focusedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          focusedgradientShape || "circle"
        } at ${focusedgradientPosition || "center"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"} ${focusedpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructActivatedGradientString = () => {
    const {
      activatedbackgroundGradientImage,
      activatedgradientDirection,
      activatedgradientShape,
      activatedgradientPosition,
      activatedstartColor,
      activatedendColor,
      activatedgradientAngle,
      activatedpatternLength,
    } = radio;

    switch (activatedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${activatedgradientDirection || "to right"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${activatedgradientShape || "circle"} at ${
          activatedgradientPosition || "center"
        }, ${activatedstartColor || "#ff7e5f"}, ${
          activatedendColor || "#feb47b"
        })`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${
          activatedgradientAngle || "45"
        }deg, ${activatedstartColor || "#606dbc"}, ${
          activatedendColor || "#465298"
        } ${activatedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          activatedgradientShape || "circle"
        } at ${activatedgradientPosition || "center"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"} ${
          activatedpatternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };

  useEffect(() => {
    const fetchBackgroundImage = async () => {
      if (radio.backgroundImage && radio.backgroundImage.startsWith("./")) {
        const imageName = radio.backgroundImage.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setBackgroundImageUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setBackgroundImageUrl(radio.backgroundImage);
      }
    };

    fetchBackgroundImage();
  }, [radio.backgroundImage, files]);

  useEffect(() => {
    const fetchlabelbackgroundImagelabel = async () => {
      if (
        radio.labelbackgroundImagelabel &&
        radio.labelbackgroundImagelabel.startsWith("./")
      ) {
        const imageName = radio.labelbackgroundImagelabel.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setlabelbackgroundImagelabelUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setlabelbackgroundImagelabelUrl(radio.labelbackgroundImagelabel);
      }
    };

    fetchlabelbackgroundImagelabel();
  }, [radio.labelbackgroundImagelabel, files]);

  const focusedStyles =
    isDivFocused && radio.pseudoClass === "focus"
      ? {
          // width: radio.focusedwidth || radio.width || "auto",
          // height: radio.focusedheight || radio.height || "auto",

          padding: radio.focusedpadding || radio.padding || "0",
          paddingTop:
            radio.focusedpaddingTop || radio.focusedpadding || "0",
          paddingRight:
            radio.focusedpaddingRight || radio.focusedpadding || "3px",
          paddingBottom:
            radio.focusedpaddingBottom || radio.focusedpadding || "0",
          paddingLeft:
            radio.focusedpaddingLeft || radio.focusedpadding || "3px",
          margin: radio.focusedmargin || radio.margin || "0px",
          marginTop:
            radio.focusedmarginTop || radio.focusedmargin || "0px",
          marginRight:
            radio.focusedmarginRight || radio.focusedmargin || "0px",
          marginBottom:
            radio.focusedmarginBottom || radio.focusedmargin || "0px",
          marginLeft:
            radio.focusedmarginLeft || radio.focusedmargin || "0px",

          borderTop:
            radio.focusedborderTop ||
            radio.focusedborder ||
            radio.border ||
            "none",
          borderRight:
            radio.focusedborderRight ||
            radio.focusedborder ||
            radio.border ||
            "none",
          borderBottom:
            radio.focusedborderBottom ||
            radio.focusedborder ||
            radio.border ||
            "none",
          borderLeft:
            radio.focusedborderLeft ||
            radio.focusedborder ||
            radio.border ||
            "none",
          borderSapcing:
            radio.focusedborderSpacing || radio.borderSpacing || "0px",
          borderCollapse:
            radio.focusedborderCollapse || radio.borderCollapse || "0px",
          borderRadius:
            radio.focusedborderRadius || radio.borderRadius || "0",
          outline: radio.focusedoutline || radio.outline || "none",

          position: radio.focusedposition || radio.position || "relative",
          top: radio.focusedtop || radio.top || "auto",
          right: radio.focusedright || radio.right || "auto",
          bottom: radio.focusedbottom || radio.bottom || "auto",
          left: radio.focusedleft || radio.left || "auto",
          zIndex: radio.focusedzIndex || radio.zIndex || "auto",

          color: radio.focusedcolor || radio.color || "#000000",
          backgroundColor:
            radio.focusedbackgroundColor ||
            radio.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (radio.focusedbackgroundImage) {
              if (radio.focusedbackgroundImage.startsWith("./")) {
                const imageName = radio.focusedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${radio.focusedbackgroundImage})`;
            }
            if (radio.backgroundImage) {
              if (radio.backgroundImage.startsWith("./")) {
                const imageName = radio.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${radio.backgroundImage})`;
            }
            return (
              constructFocusedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            radio.focusedbackgroundPosition ||
            radio.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            radio.focusedbackgroundSize || radio.backgroundSize || "auto",
          backgroundRepeat:
            radio.focusedbackgroundRepeat ||
            radio.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            radio.focusedbackgroundAttachment ||
            radio.backgroundAttachment ||
            "scroll",

          boxShadow: radio.focusedboxShadow || radio.boxShadow || "none",
          opacity: radio.focusedOpacity || radio.opacity || 1,
          display: radio.focuseddisplay || radio.display || "inline",

          cursor: radio.focusedcursor || radio.cursor || "default",
          transform: radio.focusedtransform || radio.transform || "none",
          transition:
            radio.focusedtransition || radio.transition || "none",
        }
      : {};
  const hoverStyles =
    isDivHovered && radio.pseudoClass === "hover"
      ? {
          // width: radio.hoveredwidth || radio.width || "auto",
          // height: radio.hoveredheight || radio.height || "auto",

          padding: radio.hoveredpadding || radio.padding || "0",
          paddingTop:
            radio.hoveredpaddingTop || radio.hoveredpadding || "0",
          paddingRight:
            radio.hoveredpaddingRight || radio.hoveredpadding || "3px",
          paddingBottom:
            radio.hoveredpaddingBottom || radio.hoveredpadding || "0",
          paddingLeft:
            radio.hoveredpaddingLeft || radio.hoveredpadding || "3px",
          margin: radio.hoveredmargin || radio.margin || "0px",
          marginTop:
            radio.hoveredmarginTop || radio.hoveredmargin || "0px",
          marginRight:
            radio.hoveredmarginRight || radio.hoveredmargin || "0px",
          marginBottom:
            radio.hoveredmarginBottom || radio.hoveredmargin || "0px",
          marginLeft:
            radio.hoveredmarginLeft || radio.hoveredmargin || "0px",

          borderTop:
            radio.hoveredborderTop ||
            radio.hoveredborder ||
            radio.border ||
            "none",
          borderRight:
            radio.hoveredborderRight ||
            radio.hoveredborder ||
            radio.border ||
            "none",
          borderBottom:
            radio.hoveredborderBottom ||
            radio.hoveredborder ||
            radio.border ||
            "none",
          borderLeft:
            radio.hoveredborderLeft ||
            radio.hoveredborder ||
            radio.border ||
            "none",
          borderSapcing:
            radio.hoveredborderSpacing || radio.borderSpacing || "0px",
          borderCollapse:
            radio.hoveredborderCollapse || radio.borderCollapse || "0px",
          borderRadius:
            radio.hoveredborderRadius || radio.borderRadius || "0",
          outline: radio.hoveredoutline || radio.outline || "none",

          position: radio.hoveredposition || radio.position || "relative",
          top: radio.hoveredtop || radio.top || "auto",
          right: radio.hoveredright || radio.right || "auto",
          bottom: radio.hoveredbottom || radio.bottom || "auto",
          left: radio.hoveredleft || radio.left || "auto",
          zIndex: radio.hoveredzIndex || radio.zIndex || "auto",

          color: radio.hoveredcolor || radio.color || "#000000",
          backgroundColor:
            radio.hoveredbackgroundColor ||
            radio.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (radio.hoveredbackgroundImage) {
              if (radio.hoveredbackgroundImage.startsWith("./")) {
                const imageName = radio.hoveredbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${radio.hoveredbackgroundImage})`;
            }
            if (radio.backgroundImage) {
              if (radio.backgroundImage.startsWith("./")) {
                const imageName = radio.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${radio.backgroundImage})`;
            }
            return (
              constructHoverGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            radio.hoveredbackgroundPosition ||
            radio.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            radio.hoveredbackgroundSize || radio.backgroundSize || "auto",
          backgroundRepeat:
            radio.hoveredbackgroundRepeat ||
            radio.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            radio.hoveredbackgroundAttachment ||
            radio.backgroundAttachment ||
            "scroll",

          boxShadow: radio.hoveredboxShadow || radio.boxShadow || "none",
          opacity: radio.hoveredOpacity || radio.opacity || 1,
          display: radio.hovereddisplay || radio.display || "inline",

          cursor: radio.hoveredcursor || radio.cursor || "default",
          transform: radio.hoveredtransform || radio.transform || "none",
          transition:
            radio.hoveredtransition || radio.transition || "none",
        }
      : {};
  const activeStyles =
    isDivActive && radio.pseudoClass === "active"
      ? {
          // width: radio.activatedwidth || radio.width || "200px",
          // height: radio.activatedheight || radio.height || "auto",

          padding: radio.activatedpadding || radio.padding || "0",
          paddingTop:
            radio.activatedpaddingTop || radio.activatedpadding || "0",
          paddingRight:
            radio.activatedpaddingRight ||
            radio.activatedpadding ||
            "3px",
          paddingBottom:
            radio.activatedpaddingBottom || radio.activatedpadding || "0",
          paddingLeft:
            radio.activatedpaddingLeft || radio.activatedpadding || "3px",
          margin: radio.activatedmargin || radio.margin || "0px",
          marginTop:
            radio.activatedmarginTop || radio.activatedmargin || "0px",
          marginRight:
            radio.activatedmarginRight || radio.activatedmargin || "0px",
          marginBottom:
            radio.activatedmarginBottom || radio.activatedmargin || "0px",
          marginLeft:
            radio.activatedmarginLeft || radio.activatedmargin || "0px",

          borderTop:
            radio.activatedborderTop ||
            radio.activatedborder ||
            radio.border ||
            "none",
          borderRight:
            radio.activatedborderRight ||
            radio.activatedborder ||
            radio.border ||
            "none",
          borderBottom:
            radio.activatedborderBottom ||
            radio.activatedborder ||
            radio.border ||
            "none",
          borderLeft:
            radio.activatedborderLeft ||
            radio.activatedborder ||
            radio.border ||
            "none",
          borderSapcing:
            radio.activatedborderSpacing || radio.borderSpacing || "0px",
          borderCollapse:
            radio.activatedborderCollapse ||
            radio.borderCollapse ||
            "0px",
          borderRadius:
            radio.activatedborderRadius || radio.borderRadius || "0",
          outline: radio.activatedoutline || radio.outline || "none",

          position:
            radio.activatedposition || radio.position || "relative",
          top: radio.activatedtop || radio.top || "auto",
          right: radio.activatedright || radio.right || "auto",
          bottom: radio.activatedbottom || radio.bottom || "auto",
          left: radio.activatedleft || radio.left || "auto",
          zIndex: radio.activatedzIndex || radio.zIndex || "auto",

          color: radio.activatedcolor || radio.color || "#000000",
          backgroundColor:
            radio.activatedbackgroundColor ||
            radio.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (radio.activatedbackgroundImage) {
              if (radio.activatedbackgroundImage.startsWith("./")) {
                const imageName = radio.activatedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${radio.activatedbackgroundImage})`;
            }
            if (radio.backgroundImage) {
              if (radio.backgroundImage.startsWith("./")) {
                const imageName = radio.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${radio.backgroundImage})`;
            }
            return (
              constructActivatedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            radio.activatedbackgroundPosition ||
            radio.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            radio.activatedbackgroundSize ||
            radio.backgroundSize ||
            "auto",
          backgroundRepeat:
            radio.activatedbackgroundRepeat ||
            radio.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            radio.activatedbackgroundAttachment ||
            radio.backgroundAttachment ||
            "scroll",

          boxShadow:
            radio.activatedboxShadow || radio.boxShadow || "none",
          opacity: radio.activatedOpacity || radio.opacity || 1,
          display: radio.activateddisplay || radio.display || "inline",

          cursor: radio.activatedcursor || radio.cursor || "default",
          transform:
            radio.activatedtransform || radio.transform || "none",
          transition:
            radio.activatedtransition || radio.transition || "none",
        }
      : {};

  const inputStyle = {
    width: radio.width || "auto",
    height: radio.height || "auto",

    margin: radio.margin || "0px",
    marginTop: radio.marginTop || radio.margin || "0",
    marginRight: radio.marginRight || radio.margin || "0px",
    marginBottom: radio.marginBottom || radio.margin || "0",
    marginLeft: radio.marginLeft || radio.margin || "0px",
    padding: radio.padding || "0px",
    paddingTop: radio.paddingTop || radio.padding || "0px",
    paddingRight: radio.paddingRight || radio.padding || "3px",
    paddingBottom: radio.paddingBottom || radio.padding || "0px",
    paddingLeft: radio.paddingLeft || radio.padding || "3px",

    borderTop: isHovered
      ? "1px dashed #555"
      : radio.borderTop || radio.border || "none",
    borderRight: isHovered
      ? "1px dashed #555"
      : radio.borderRight || radio.border || "none",
    borderBottom: isHovered
      ? "1px dashed #555"
      : radio.borderBottom || radio.border || "none",
    borderLeft: isHovered
      ? "1px dashed #555"
      : radio.borderLeft || radio.border || "none",

    borderSapcing: radio.borderSpacing || "0px",
    borderCollapse: radio.borderCollapse || "0px",
    borderRadius: radio.borderRadius || "0",
    outline: radio.outline || "none",

    position: radio.position || "static",
    top: radio.top || "auto",
    right: radio.right || "auto",
    bottom: radio.bottom || "auto",
    left: radio.left || "auto",
    zIndex: radio.zIndex || "auto",

    color: radio.color || "#000000",
    backgroundColor: radio.backgroundColor || "#ffffff",
    backgroundImage: backgroundImageUrl
      ? `url(${backgroundImageUrl})`
      : constructGradientString(),
    backgroundPosition:
      radio.focusedbackgroundPosition ||
      radio.backgroundPosition ||
      "0% 0%",
    backgroundSize:
      radio.focusedbackgroundSize || radio.backgroundSize || "auto",
    backgroundRepeat:
      radio.focusedbackgroundRepeat || radio.backgroundRepeat || "repeat",
    backgroundAttachment:
      radio.focusedbackgroundAttachment ||
      radio.backgroundAttachment ||
      "scroll",

    opacity: radio.opacity || "1",
    display: radio.display || "inline",
    cursor: radio.cursor || "auto",

    transform: radio.transform || "none",
    transition: radio.transition || "none",

    scale: isHovered ? "1.01" : "1",
    ...hoverStyles,
    ...focusedStyles,
    ...activeStyles,
  };

  const labelStyle = {
    margin: radio.labelmargin || "0px",
    marginTop: radio.labelmarginTop || radio.labelmargin || "0",
    marginRight: radio.labelmarginRight || radio.labelmargin || "10px",
    marginBottom: radio.labelmarginBottom || radio.labelmargin || "0",
    marginLeft: radio.labelmarginLeft || radio.labelmargin || "10px",
    padding: radio.labelpadding || "0px",
    paddingTop: radio.labelpaddingTop || radio.labelpadding || "0",
    paddingRight: radio.labelpaddingRight || radio.labelpadding || "0",
    paddingBottom: radio.labelpaddingBottom || radio.labelpadding || "0",
    paddingLeft: radio.labelpaddingLeft || radio.labelpadding || "0",

    borderTop: isHovered
      ? "1px dashed #555"
      : radio.labelborderTop || radio.labelborder || "none",
    borderRight: isHovered
      ? "1px dashed #555"
      : radio.labelborderRight || radio.labelborder || "none",
    borderBottom: isHovered
      ? "1px dashed #555"
      : radio.labelborderBottom || radio.labelborder || "none",
    borderLeft: isHovered
      ? "1px dashed #555"
      : radio.labelborderLeft || radio.labelborder || "none",

    borderSapcing: radio.labelborderSpacing || "0px",
    borderCollapse: radio.labelborderCollapse || "0px",
    borderRadius: radio.labelborderRadius || "0",
    outline: radio.labeloutline || "none",

    position: radio.labelposition || "static",
    top: radio.labeltop || "auto",
    right: radio.labelright || "auto",
    bottom: radio.labelbottom || "auto",
    left: radio.labelleft || "auto",
    zIndex: radio.labelzIndex || "auto",

    color: radio.labelcolor || "#000000",
    backgroundColor: radio.labelbackgroundColor || "#ffffff",
    backgroundImage: backgroundImagelabelUrl
      ? `url(${backgroundImagelabelUrl})`
      : labelconstructGradientString(),
    backgroundPosition:
      radio.labelbackgroundPosition ||
      radio.labelbackgroundPosition ||
      "0% 0%",
    backgroundSize:
      radio.labelbackgroundSize || radio.labelbackgroundSize || "auto",
    backgroundRepeat:
      radio.labelbackgroundRepeat ||
      radio.labelbackgroundRepeat ||
      "repeat",
    backgroundAttachment:
      radio.labelbackgroundAttachment ||
      radio.labelbackgroundAttachment ||
      "scroll",

    fontSize: radio.labelfontSize || "inherit",
    fontFamily: radio.labelfontFamily || "inherit",
    fontWeight: radio.labelfontWeight || "normal",
    fontStyle: radio.labelfontStyle || "normal",
    fontVariant: radio.labelfontVariant || "normal",
    lineHeight: radio.labellineHeight || "normal",
    textAlign: radio.labeltextAlign || "left",
    textDecoration: radio.labeltextDecoration || "none",
    textTransform: radio.labeltextTransform || "none",
    textShadow: radio.labeltextShadow || "none",
    verticalAlign: radio.labelverticalAlign || "baseline",
    letterSpacing: radio.labelletterSpacing || "normal",
    wordSpacing: radio.labelwordSpacing || "normal",
    textIndent: radio.labeltextIndent || "0",
    whiteSpace: radio.labelwhiteSpace || "normal",
    textOverflow: radio.labeltextOverflow || "clip",
    direction: radio.labeldirection || "ltr",
    unicodeBidi: radio.labelunicodeBidi || "normal",
    writingMode: radio.labelwritingMode || "horizontal-tb",

    opacity: radio.labelopacity || "1",
    display: radio.display || "inline",
    cursor: radio.cursor || "auto",

    transform: radio.transform || "none",
    transition: radio.transition || "none",
  };

  return (
    <>
      <input
        type="radio"
        name={radio.groupName}
        checked={isChecked}
        disabled={radio.disabled || false}
        style={inputStyle}
        onMouseEnter={() => setIsDivHovered(true)}
        onMouseLeave={() => setIsDivHovered(false)}
        onFocus={() => setIsDivFocused(true)}
        onBlur={() => setIsDivFocused(false)}
        onMouseDown={() => setIsDivActive(true)}
        onMouseUp={() => setIsDivActive(false)}
        onChange={(e) => handleCheckboxChange(e.target.checked)}
      />
      <label style={labelStyle}>{radio.label || "Radio Button"}</label>
    </>
  );
};

export default RadioComponent;
